import { StoreFactory, StorePlugin, Vue, Vuex } from 'vue-infra';
import { mapValues } from 'lodash';
import { appName } from '../../config';

import data, { MODULES_PATHS as dataModulesPaths } from './modules/data';

Vue.use(Vuex);
Vue.use(StorePlugin, { Vuex });

const appModule = {
  namespaced: true,
  strict: true,
  modules: {
    data,
  },
};
const dataModuleMappedPaths = mapValues(dataModulesPaths, path => `${appName}/${path}`);

const storeFactory = new StoreFactory(appName, Vue);
storeFactory.load(appModule);

const store = storeFactory.register();

export default store;

export const MODULES_PATHS = {
  DATA: dataModuleMappedPaths,
};
